// eslint-disable-next-line @typescript-eslint/no-unused-vars,prettier/prettier
import {createSlice, PayloadAction} from '@reduxjs/toolkit';
// eslint-disable-next-line prettier/prettier
import {
	AuthState,
} from './typedefs';

const initialState: AuthState = {
  isFetching: false,
  allowCountdown: false,
  isInitialised: false,
  isAuthenticated: false,
  signUpEmail: '',
  resentCodeTimer: 0,
};

const authSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    startFetching(state) {
      state.isFetching = true;
    },
    stopFetching(state) {
      state.isFetching = false;
    },
    allowCountdown(state, action: PayloadAction<boolean>) {
      state.allowCountdown = action.payload;
    },
    clearData(state) {
      state.allowCountdown = false;
      localStorage.clear();
      sessionStorage.clear();
    },
    initialize(state) {
      state.isInitialised = true;
    },
    isAuthenticatedTrue(state) {
      state.isAuthenticated = true;
    },
    isAuthenticatedFalse(state) {
      state.isAuthenticated = false;
    },
    setEmail(state, action: PayloadAction<string>) {
      state.signUpEmail = action.payload;
    },
    setResentCodeTimer(state, action: PayloadAction<number>) {
      state.resentCodeTimer = action.payload;
    },
    // INJECT
  },
});

export default authSlice;
